var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIotWeather(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.949,
    height: 40.568,
    viewBox: "0 0 53.949 40.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5825",
    "data-name": "Group 5825",
    transform: "translate(-435.914 -91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5819",
    "data-name": "Group 5819",
    transform: "translate(435.914 91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M3614.722,327.489a9.912,9.912,0,1,1-9.912-9.912A9.912,9.912,0,0,1,3614.722,327.489Z",
    transform: "translate(-3587.089 -309.52)",
    fill: "#ffde3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M3602.9,313.4l1.321-3.4a.76.76,0,0,1,1.43.035l1.134,3.4a.76.76,0,0,1-.721,1h-2.456A.759.759,0,0,1,3602.9,313.4Z",
    transform: "translate(-3587.091 -309.518)",
    fill: "#ffde3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M3602.9,341.006l1.321,3.4a.76.76,0,0,0,1.43-.035l1.134-3.4a.761.761,0,0,0-.721-1h-2.456A.76.76,0,0,0,3602.9,341.006Z",
    transform: "translate(-3587.091 -309.528)",
    fill: "#ffde3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M3590.971,329.4l-3.4-1.323a.76.76,0,0,1,.035-1.43l3.4-1.133a.76.76,0,0,1,1,.721v2.455A.76.76,0,0,1,3590.971,329.4Z",
    transform: "translate(-3587.086 -309.523)",
    fill: "#ffde3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    d: "M3618.576,329.4l3.4-1.323a.76.76,0,0,0-.035-1.43l-3.4-1.133a.76.76,0,0,0-1,.721v2.455A.76.76,0,0,0,3618.576,329.4Z",
    transform: "translate(-3587.096 -309.523)",
    fill: "#ffde3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M3593.691,318.767l-1.469-3.339a.76.76,0,0,1,1.036-.986l3.206,1.6a.761.761,0,0,1,.2,1.218L3594.924,319A.76.76,0,0,1,3593.691,318.767Z",
    transform: "translate(-3587.088 -309.519)",
    fill: "#ffde3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M3613.209,338.287l3.342,1.469a.76.76,0,0,0,.986-1.036l-1.6-3.207a.76.76,0,0,0-1.218-.2l-1.736,1.737A.76.76,0,0,0,3613.209,338.287Z",
    transform: "translate(-3587.094 -309.526)",
    fill: "#ffde3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M3596.563,338.515l-3.339,1.469a.76.76,0,0,1-.986-1.036l1.6-3.207a.76.76,0,0,1,1.217-.2l1.737,1.737A.761.761,0,0,1,3596.563,338.515Z",
    transform: "translate(-3587.088 -309.526)",
    fill: "#ffde3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M3616.083,318.995l1.467-3.339a.76.76,0,0,0-1.036-.986l-3.2,1.6a.759.759,0,0,0-.2,1.217l1.735,1.735A.761.761,0,0,0,3616.083,318.995Z",
    transform: "translate(-3587.094 -309.519)",
    fill: "#ffde3b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4096",
    "data-name": "Path 4096",
    d: "M14,442.655H34.491c5.789,0,9.257-4.011,9.152-9.165s-4-9.046-10.159-7.741a9.443,9.443,0,0,0-11.3-7.618,9.1,9.1,0,0,0-7.048,9.994c-5.006.051-9.5,3.877-9,8.867S12.191,442.655,14,442.655Z",
    transform: "translate(445.218 -312.087)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotWeather);
export default __webpack_public_path__ + "static/media/iotWeather.92ac0d69f934ba49f37ce5e016eb0f93.svg";
export { ForwardRef as ReactComponent };